import AsyncAutocomplete from "components/common/Autocomplete";
import Button from "components/common/Button";
import DialogFormation from "components/common/DialogFormation";
import { useTranslate } from "hooks/useTranslate";
import { isNull } from "lodash";
import { useState } from "react";
import { useForm } from "react-hook-form";
import "./AddUser.scss";

interface MapUserToInnCodeProps {
  selectedInnCode: string;
  isAddUserOpen: boolean;
  handleClose: () => void;
  handleMemberList: (val: any) => void;
  innCodeAssignee: string[];
  isMultiple?: boolean;
}

const MapUserToInnCode = (props: MapUserToInnCodeProps) => {
  const translate = useTranslate();
  const { selectedInnCode, handleMemberList, innCodeAssignee, isMultiple = false } = props;
  const [hltId, setHltId] = useState<string>("");
  const { watch } = useForm({ defaultValues: { user: [], innCode: "" } });

  return (
    <>
      {props.isAddUserOpen && (
        <DialogFormation
          title={translate("common.addTeamMembers")}
          contentClass="map-userInncode-content"
          openDialog={props.isAddUserOpen}
          handleClose={props.handleClose}
          actionConfig={
            <div className="modal-config-wrapper">
              <Button
                variant="secondary"
                label="Cancel"
                onClick={() => {
                  props.handleClose();
                }}
              />
              <Button
                variant="primary"
                label={translate("common.addTeamMembers")}
                disabled={isMultiple ? hltId.length === 0 : hltId === "" || isNull(hltId)}
                onClick={() => {
                  handleMemberList(hltId);
                  props.handleClose();
                }}
              />
            </div>
          }
        >
          <div className="map-userInncode-component">
            <AsyncAutocomplete
              showIcon={false}
              multiple={isMultiple}
              getUserDetail={(val) => {}}
              getUserInfo={(val) => {
                setHltId(val);
              }}
              placeholder="Search by Team Member"
              searchParams={{ innCode: selectedInnCode }}
              isCurrentMemberExcluded={true}
              excludedMember={innCodeAssignee}
              includecorpusers={false}
            />
          </div>
        </DialogFormation>
      )}
    </>
  );
};

export default MapUserToInnCode;
